import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheckmarkGreen = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 1024 1024",
	fill: "none",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M307.206 716.801l-199.111-199.111c-22.187-22.187-57.458-22.187-79.644 0s-22.187 57.458 0 79.645l238.364 238.366c22.187 22.187 58.027 22.187 80.213 0l603.025-602.455c22.187-22.187 22.187-57.458 0-79.644s-57.46-22.187-79.647 0l-563.201 563.2z",
		fill: "rgb(0, 164, 99)"
	})
});
const ForwardRef = forwardRef(SvgCheckmarkGreen);
export default ForwardRef;
